import { useState, useEffect } from 'react';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

export type RecommendedUsers = {
	loading: boolean;
	errors: unknown[] | undefined;
	recommendedUsers: RecommendedUser[] | undefined;
};
type RecommendedUser = {
	key: string;
	name: string;
	href: string;
	src: string;
};
export const useGetRecommendedUsers = (skip: boolean | undefined): RecommendedUsers => {
	const accountId = useAccountId();
	const cloudId = useCloudId();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState<{
		errors: unknown[];
		recommendedUsers: RecommendedUser[];
	}>();

	useEffect(() => {
		const searchQuery = {
			context: {
				contextType: 'Generic',
				principalId: accountId,
				siteId: cloudId,
				productKey: 'jira',
			},
			searchQuery: {
				queryString: '',
				customQuery: '',
				minimumAccessLevel: 'SITE',
			},
			maxNumberOfResults: 2,
		};
		const getRecommendedUser = async () => {
			try {
				const response = await fetchJson('/gateway/api/v1/recommendations', {
					method: 'POST',
					body: JSON.stringify(searchQuery),
					headers: {
						Accept: 'application/json',
					},
				});
				const mappedUsers = response.recommendedUsers?.map(
					({ id, name, avatarUrl }: { id: string; name: string; avatarUrl: string }) => ({
						key: id,
						name,
						href: '#',
						src: avatarUrl,
					}),
				);
				setData({
					recommendedUsers: mappedUsers,
					errors: response.errors,
				});
			} catch (error) {
				setData({
					errors: [error],
					recommendedUsers: [],
				});
			} finally {
				setLoading(false);
			}
		};
		if (!skip) {
			getRecommendedUser();
		}
	}, [accountId, skip, cloudId]);
	return {
		errors: data?.errors,
		recommendedUsers: data?.recommendedUsers,
		loading: skip ? false : loading,
	};
};
